"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setSendBox;
exports.SET_SEND_BOX = void 0;
var SET_SEND_BOX = 'WEB_CHAT/SET_SEND_BOX';
exports.SET_SEND_BOX = SET_SEND_BOX;

function setSendBox(text) {
  return {
    type: SET_SEND_BOX,
    payload: {
      text: text
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldFNlbmRCb3guanMiXSwibmFtZXMiOlsiU0VUX1NFTkRfQk9YIiwic2V0U2VuZEJveCIsInRleHQiLCJ0eXBlIiwicGF5bG9hZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLFlBQVksR0FBRyx1QkFBckI7OztBQUVlLFNBQVNDLFVBQVQsQ0FBb0JDLElBQXBCLEVBQTBCO0FBQ3ZDLFNBQU87QUFDTEMsSUFBQUEsSUFBSSxFQUFFSCxZQUREO0FBRUxJLElBQUFBLE9BQU8sRUFBRTtBQUFFRixNQUFBQSxJQUFJLEVBQUpBO0FBQUY7QUFGSixHQUFQO0FBSUQiLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTRVRfU0VORF9CT1ggPSAnV0VCX0NIQVQvU0VUX1NFTkRfQk9YJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2V0U2VuZEJveCh0ZXh0KSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogU0VUX1NFTkRfQk9YLFxuICAgIHBheWxvYWQ6IHsgdGV4dCB9XG4gIH07XG59XG5cbmV4cG9ydCB7IFNFVF9TRU5EX0JPWCB9O1xuIl19